import React, { useEffect, useState } from "react"

const LazyImage = React.memo(
    ({ className, placeHolderClassName, src, alt }) => {
        const [isLoaded, setIsLoaded] = useState(false)

        useEffect(() => {
            if (!src) {
                setIsLoaded(false)
                return
            }
            const img = new Image()
            img.src = src
            img.onload = () => setIsLoaded(true)
            img.onerror = () => setIsLoaded(true)
        }, [])

        return (
            <div>
                {isLoaded ? (
                    <img
                        src={src}
                        alt={alt}
                        className={className}
                        draggable="false"
                    />
                ) : (
                    <div className={placeHolderClassName} />
                )}
            </div>
        )
    },
)

export default LazyImage
